import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/estadoProyectoParticipanteFinal';

const getEstadoProyectoParticipanteFinal = async (codigoProyecto) => {
  try {
    const response = await axios.get(
      `${baseUrl}${endpoint}/${codigoProyecto}`
    );

    return {
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error(
      '❌ Error fetching estado proyecto participante final:',
      error
    );

    return {
      status: error.response ? error.response.status : 500,
      message: 'Error consultando estado del proyecto'
    };
  }
};

export default getEstadoProyectoParticipanteFinal;
